import React, { FC, PropsWithChildren } from "react";
import { useESignFieldSetupAction, useESignSigningAction } from "./esign-signing-action";

export const ESignSigningActionAccessor: FC<PropsWithChildren<{}>> = ({ children }) => {
    useESignFieldSetupAction(); // registers "Open ESign Field Setup" for the initiator
    useESignSigningAction();    // registers "Open ESign Signing" for each signatory
    return <>{children}</>;
};
